import { app } from './chat/app';
import { thread } from './chat/thread';

export const mock = {
  app,
  thread,
};
